import { render, staticRenderFns } from "./IconSvgNYSSCPAChapters.vue?vue&type=template&id=28dce80f&scoped=true&"
import script from "./IconSvgNYSSCPAChapters.vue?vue&type=script&lang=js&"
export * from "./IconSvgNYSSCPAChapters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dce80f",
  null
  
)

export default component.exports